import {
    Edit,
    Shield,
    ShieldCheck,
} from 'lucide-react';

export const roles = [
    { value: 'admin', label: 'Admin', description: 'Full access to all features', icon: ShieldCheck },
    { value: 'manager', label: 'Manager', description: 'Can manage projects and blogs', icon: Shield },
    { value: 'editor', label: 'Editor', description: 'Can create and edit content', icon: Edit }
];

export const getRoleColor = (role) => {
    switch (role) {
        case 'admin': return 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300';
        case 'manager': return 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300';
        case 'editor': return 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300';
        default: return 'bg-gray-100 text-gray-800 dark:bg-gray-900/20 dark:text-gray-300';
    }
};

export const getRolePermissions = (role) => {
    switch (role) {
        case 'admin':
            return ['All Permissions', 'User Management', 'System Settings'];
        case 'manager':
            return ['Projects', 'Blogs', 'Analytics', 'Users View'];
        case 'editor':
            return ['Create Blogs', 'Edit Blogs', 'View Analytics'];
        default:
            return [];
    }
};